import { Component, Input, OnDestroy } from '@angular/core';
import { ComputedFrom } from '@certemy/common';
import { REJECT_HINT_TYPES } from '../hint.constants';
import { TypeConfig } from '../hint.interface';

@Component({
  selector: 'cm-optional-hint',
  templateUrl: './optional-hint.component.html',
  styleUrls: ['./optional-hint.component.scss'],
})
export class OptionalHintComponent implements OnDestroy {
  @Input() type: REJECT_HINT_TYPES;
  @Input() organizationContactData = { name: '', email: '' };
  readonly REJECT_HINT_TYPES = REJECT_HINT_TYPES;

  @ComputedFrom('type', 'organizationContactData')
  get typeConfig(): TypeConfig {
    return this.generateTypeConfig();
  }

  constructor() {}

  ngOnDestroy() {}

  private generateTypeConfig(): TypeConfig {
    const valueHandleMap = {
      [REJECT_HINT_TYPES.OPTIONAL_PHASE]: {
        label: 'OPTIONAL <br />PHASE',
        title: 'Optional phase',
      },
      [REJECT_HINT_TYPES.OPTIONAL_STEP]: {
        label: 'OPTIONAL <br />STEP',
        title: 'Optional step',
      },
    };

    return {
      confirmButtonText: '',
      organizationContactData: this.organizationContactData,
      ...valueHandleMap[this.type],
    };
  }
}
